<template>
    <b-tab :title="$store.state.localization.data.mainPage.drivers.mainTabLabel" active>
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.lastName"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="driver.lastName"
            :state="isLastNameValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.firstName"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="driver.firstName"
            :state="isFirstNameValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.patronymic"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="driver.patronymic"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          locale="ua"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.birthDate"
          label-for="input-horizontal"
        >
          <b-form-datepicker
            v-model="driver.birthDate"
            value-as-date="true"
            style="font-size: 13px"
            :locale="calendarLocale"
          ></b-form-datepicker>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.gender"
          label-for="input-horizontal"
        >
          <b-form-select
            v-model="driver.gender"
            :state="isGenderValid"
            :options="genderOptions"
            style="font-size: 13px"
          ></b-form-select>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.rfid"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="driver.rfid"
            :state="isRfidValid"
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.phoneNumber"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="driver.phoneNumber"
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.vehicleRegisterNumber"
          label-for="input-horizontal"
        >
          <b-form-select
            v-model="driver.vehicleId"
            :options="vehicleOptions"
            style="font-size: 13px"
          ></b-form-select>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.company"
          label-for="input-horizontal"
        >
          <b-form-select
            v-model="driver.companyId"
            :state="isCompanyValid"
            :options="companyOptions"
            style="font-size: 13px"
          ></b-form-select>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.drivers.tableColumns.description"
          label-for="input-horizontal"
        >
          <b-form-textarea
            v-model="driver.description"
            style="font-size: 13px"
          ></b-form-textarea>
        </b-form-group>
      </b-tab>
  </template>
  
  <script>
  
  import { utilsService } from "../../../services";

  export default {
    name: "MainTab",
    props: {
      driver: Object,
      vehicles: Array,
      companies: Array,
    },
    data() {
      return {
        isLastNameValid: null,
        isFirstNameValid: null,
        isGenderValid: null,
        isRfidValid: null,
        isCompanyValid: null,
      };
    },
    computed: {
      genderOptions() {
        const genderOptions = [];
  
        for (
          let i = 0;
          i <
          this.$store.state.localization.data.mainPage.drivers.genderOptions
            .length;
          i++
        ) {
          genderOptions.push({
            value:
              this.$store.state.localization.data.mainPage.drivers.genderOptions[
                i
              ].key,
            text: this.$store.state.localization.data.mainPage.drivers
              .genderOptions[i].value,
          });
        }
        return genderOptions;
      },
      vehicleOptions() {
        const vehicleOptions = [];
  
        for (let i = 0; i < this.vehicles.length; i++) {
          vehicleOptions.push({
            value: this.vehicles[i].id,
            text: this.vehicles[i].registerNumber,
          });
        }
        return vehicleOptions;
      },
      companyOptions() {
        const companyOptions = [];
  
        for (let i = 0; i < this.companies.length; i++) {
          companyOptions.push({
            value: this.companies[i].id,
            text: this.companies[i].name,
          });
        }
        return companyOptions;
      },
      calendarLocale() {
        return utilsService.getCalendarLocale(this.$store.state.localization.locale);
      }
    },
    methods: {
      validate() {
        let isValid = true;

        if (!this.driver.lastName) {
          this.isLastNameValid = false;
          isValid = false;
        } else {
          this.isLastNameValid = null;
        }
  
        if (!this.driver.firstName) {
          this.isFirstNameValid = false;
          isValid = false;
        } else {
          this.isFirstNameValid = null;
        }
  
        if (!this.driver.gender) {
          this.isGenderValid = false;
          isValid = false;
        } else {
          this.isGenderValid = null;
        }
  
        if (!this.driver.rfid) {
          this.isRfidValid = false;
          isValid = false;
        } else {
          this.isRfidValid = null;
        }
  
        if (!this.driver.companyId) {
          this.isCompanyValid = false;
          isValid = false;
        } else {
          this.isCompanyValid = null;
        }
  
        return isValid;
      },
    },
  };
  </script>
  